export enum RequestListActionTypes {
  viewRequest = 'viewRequest',
  createReport = 'createReport'
}